// crewbit-admin/src/components/money/MoneyExpenseLogPanel.styles.ts
//
// Form chrome for MoneyExpenseLogPanel (extracted at Wave 7 Step 1 to keep the
// panel under GR-14's 500-line ceiling). Same label/input shapes the slide-out
// already used inline; siblings stay independent so EditPanel can diverge.

import type { CSSProperties } from 'react';
import { palette, radii } from '../../styles/tokens';

export const labelStyle: CSSProperties = {
  display: 'block',
  fontSize: 12,
  fontWeight: 600,
  color: palette.g600,
  marginBottom: 6,
};

export const inputStyle: CSSProperties = {
  width: '100%',
  padding: '9px 12px',
  borderRadius: radii.sm,
  border: `1px solid ${palette.g200}`,
  background: palette.white,
  fontFamily: 'inherit',
  fontSize: 13.5,
  color: palette.g800,
  outline: 'none',
  boxSizing: 'border-box',
};
